var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var VerifiedWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-right: 8px;\n  color: rgba(0, 0, 0, 0.45);\n  font-weight: 500;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-right: 8px;\n  color: rgba(0, 0, 0, 0.45);\n  font-weight: 500;\n"])));
var templateObject_1;
